import { useAppSelector, useAppDispatch } from '../../store';
import colors from 'assets/scss/_themes-vars.module.scss';
import {
  Dialog,
  IconButton,
  Grid,
  DialogContent,
  Typography,
  Button,
  Box,
  Link,
  DialogTitle,
  TextField,
  DialogActions,
  CircularProgress
} from '@mui/material';
import DashnaLogo from 'assets/images/dashnaIco.svg';
import SyncAlt from 'assets/images/syncAlt.svg';
import WalmartIco from 'assets/images/walmartIco.svg';
import { useEffect,
  useState } from 'react';
import { Remove } from '@mui/icons-material';
import { updateManageStoreData, getManageStoreList } from 'store/thunk/manageStoreThunk';
const AddStoreModal = (props) => {
  const dispatch = useAppDispatch();
  const { forceStorePopup, setForceStorePopup } = props;
  const allStoreList = useAppSelector((state) => state.manageStore.list);
  const dataLoading = useAppSelector((state) => state.dataLoading);
  const setUserData = useAppSelector((state) => state.authorization);

  const primaryTextColor = colors?.primaryTextColor;
  const linkColor = colors?.linkColor;
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (!allStoreList?.length) {
      dispatch(getManageStoreList());
    }
  }, []);

  // Form states
  const [formData, setFormData] = useState({
    store_name: '',
    client_id: '',
    client_secret: '',
    advertiser_ids: ['']
  });

  // Error states
  const [errors, setErrors] = useState({
    store_name: '',
    client_id: '',
    client_secret: '',
    advertiser_ids: ['']
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    setErrors((prev) => ({
      ...prev,
      [name]: ''
    }));
  };

  const handleAdvertiserChange = (index, value) => {
    const newAdvertiserIds = [...formData.advertiser_ids];
    newAdvertiserIds[index] = value;
    setFormData((prev) => ({
      ...prev,
      advertiser_ids: newAdvertiserIds
    }));

    const newErrors = [...errors.advertiser_ids];
    newErrors[index] = '';
    setErrors((prev) => ({
      ...prev,
      advertiser_ids: newErrors
    }));
  };

  const addAdvertiserId = () => {
    setFormData((prev) => ({
      ...prev,
      advertiser_ids: [...prev.advertiser_ids, '']
    }));
    setErrors((prev) => ({
      ...prev,
      advertiser_ids: [...prev.advertiser_ids, '']
    }));
  };

  const removeAdvertiserId = (index) => {
    if (formData.advertiser_ids.length > 1) {
      setFormData((prev) => ({
        ...prev,
        advertiser_ids: prev.advertiser_ids.filter((_, i) => i !== index)
      }));
      setErrors((prev) => ({
        ...prev,
        advertiser_ids: prev.advertiser_ids.filter((_, i) => i !== index)
      }));
    }
  };

  const validateStep1 = () => {
    const newErrors = {};
    let isValid = true;

    if (!formData.store_name.trim()) {
      newErrors.store_name = 'Store Nickname is required';
      isValid = false;
    }
    if (!formData.client_id.trim()) {
      newErrors.client_id = 'Client ID is required';
      isValid = false;
    }
    if (!formData.client_secret.trim()) {
      newErrors.client_secret = 'Client Secret is required';
      isValid = false;
    }

    setErrors((prev) => ({ ...prev, ...newErrors }));
    return isValid;
  };

  const validateStep2 = () => {
    const newAdvertiserErrors = formData.advertiser_ids.map((id) => (!id.trim() ? 'Advertiser ID is required' : ''));

    const hasErrors = newAdvertiserErrors.some((error) => error !== '');
    setErrors((prev) => ({
      ...prev,
      advertiser_ids: newAdvertiserErrors
    }));

    return !hasErrors;
  };

  const handleNext = () => {
    if (validateStep1()) {
      setStep(2);
    }
  };

  console.log('formData ', formData);
  const handleSubmit = () => {
    console.log('validateStep2() ', validateStep2());
    console.log('allStoreList ', allStoreList);
    if (validateStep2()) {
      if (allStoreList?.length === 1 && allStoreList[0]?.is_default) {
        const userData = setUserData?.userData?.data;
        const storeData = allStoreList[0];
        const adIds = formData?.advertiser_ids.map((id) => ({ advertiser_id: id }));
        const request = {
          name: formData?.store_name, //store nick name added by user
          store_name: storeData?.store_name, //store default name generated by BE
          adversiter_id: adIds,
          store_id: storeData?.id,
          client_id: formData?.client_id,
          client_secret: formData?.client_secret
        };
        dispatch(
          updateManageStoreData({
            data: request,
            user_id: userData?.id,
            setForceStorePopup: setForceStorePopup
          })
        );
      }
    }
  };

  return (
    <Dialog
      maxWidth={'md'}
      open={forceStorePopup}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{ sx: { width: '760px', maxWidth: '760px' } }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex' }} alignItems={'center'} gap={2}>
          <Typography className={'fontInter'} color={primaryTextColor} variant={'h2'}>
            Connect to Walmart
          </Typography>
          <Box display={'flex'} alignItems={'center'} gap={'10px'}>
            <Link to="#">
              <img src={DashnaLogo} alt="Dashna Logo" />
            </Link>
            <Link to="#">
              <img src={SyncAlt} alt="Sync Logo" />
            </Link>
            <Link to="#">
              <img src={WalmartIco} alt="Marketplace Logo" />
            </Link>
          </Box>
        </Box>
      </DialogTitle>
      <form noValidate>
        <DialogContent dividers>
          <Grid container>
            <Grid item xs={12} pb={3.5}>
              <Typography className={'fontInter'} color={primaryTextColor} fontSize={'16px'}>
                For detailed instructions on how to connect Dashna to your Walmart account,{' '}
                <Link
                  className={'fontInter'}
                  color={linkColor}
                  fontSize={'16px'}
                  sx={{ cursor: 'pointer' }}
                  onClick={() =>
                    window.open(`https://support.dashna.com/portal/en/kb/articles/adding-a-store#How_to_Add_a_Store`, '_blank')
                  }
                >
                  Click here
                </Link>
              </Typography>
            </Grid>

            {step === 1 && (
              <>
                <Grid item xs={12} pb={1.5}>
                  <TextField
                    label="Store Nickname"
                    name="store_name"
                    value={formData.store_name}
                    onChange={handleInputChange}
                    error={!!errors.store_name}
                    helperText={errors.store_name}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} pb={1.5}>
                  <TextField
                    label="Client ID"
                    name="client_id"
                    value={formData.client_id}
                    onChange={handleInputChange}
                    error={!!errors.client_id}
                    helperText={errors.client_id}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} pb={1.5}>
                  <TextField
                    label="Client Secret"
                    name="client_secret"
                    value={formData.client_secret}
                    onChange={handleInputChange}
                    error={!!errors.client_secret}
                    helperText={errors.client_secret}
                    fullWidth
                  />
                </Grid>
              </>
            )}

            {step === 2 && (
              <>
                {formData.advertiser_ids.map((id, index) => (
                  <Grid item xs={12} key={index} display="flex" alignItems="center" pb={1.5} gap={1}>
                    <TextField
                      label={`Advertiser ID ${index + 1}`}
                      value={id}
                      onChange={(e) => handleAdvertiserChange(index, e.target.value)}
                      error={!!errors.advertiser_ids[index]}
                      helperText={errors.advertiser_ids[index]}
                      fullWidth
                    />
                    <IconButton
                      style={{
                        position: 'relative',
                        top: 0,
                        right: 0
                      }}
                      onClick={() => removeAdvertiserId(index)}
                      disabled={formData.advertiser_ids.length === 1}
                      size="small"
                      sx={{ ml: 1 }}
                    >
                      <Remove />
                    </IconButton>
                  </Grid>
                ))}

                <Grid item xs={12} pb={1.5} sx={{ textAlign: 'right', paddingRight: '50px' }}>
                  <Link
                    className={'fontInter'}
                    color={linkColor}
                    fontSize={'16px'}
                    sx={{ cursor: 'pointer' }}
                    onClick={addAdvertiserId}
                  >
                    +Add Another Advertiser ID
                  </Link>
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'flex-end', padding: 2 }}>
          <Box display="flex" gap={1}>
            {step === 2 && (
              <Button onClick={() => setStep(1)} variant="outlined" color="secondary">
                Previous
              </Button>
            )}
            {step === 1 ? (
              <Button onClick={handleNext} variant="contained" color="primary">
                Next
              </Button>
            ) : (
              <Button
                disabled={dataLoading.loading || allStoreList?.length === 0}
                onClick={handleSubmit}
                variant="contained"
                color="primary"
              >
                {dataLoading.loading && <CircularProgress sx={{ color: '#0000001f', mr: '10px' }} size="20px" />}
                Save
              </Button>
            )}
          </Box>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddStoreModal;
